import Vue from 'vue'
import Router from 'vue-router'
import Home from "../components/Home";//导航
import Content from "../components/Content";//首页
import Enterprise from "../components/Enterprise";//企业资质

import Buy from "../components/Buy";//产品介绍
import BuyGo from "../components/Buy/BuyGo";//产品展示
import Resiliometer from "../components/Buy/Resiliometer";//回弹仪
import VR from "../components/Buy/VR";//VR服务
import AR from "../components/Buy/AR";//AR服务
import Experience from "../components/Buy/Experience";//体验馆集装箱
import Quality from "../components/Buy/Quality";//质量样板展示区
import Interaction from "../components/Buy/Interaction";//互动台
import ThreeDimensional from "../components/Buy/ThreeDimensional";//三维立体展示柜

import AboutUs from "../components/AboutUs";//关于我们
import CompanyProfile from "../components/AboutUs/CompanyProfile";//公司简介

import News from "../components/News";    //新闻资讯
import NewsProfile from "../components/News/NewsProfile";//新闻简介
import NewsOne from "../components/News/NewsOne";
import NewsTwo from "../components/News/NewsTwo";
import NewsThree from "../components/News/NewsThree";
import NewsFour from "../components/News/NewsFour";
import NewsFive from "../components/News/NewsFive";
import NewsSix from "../components/News/NewsSix";
import NewsSeven from "../components/News/NewsSeven";
import NewsEight from "../components/News/NewsEight";
import NewsNine from "../components/News/NewsNine";

Vue.use(Router);

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: Home,
            children: [
                /*首页*/
                {
                    path: '/',
                    redirect: '/home/content/contentWisdomSite',
                    meta: {
                        title: '河南南秀数智科技有限公司'
                    }
                },
                {
                    path: '/home/content',
                    name: 'Content',
                    component: Content,
                    meta: {
                        title: '河南南秀数智科技有限公司'
                    },
                    children: [
                        /*智慧工地*/
                        {
                            path: '/home/content/contentWisdomSite',
                            name: 'contentWisdomSite',
                            component: () => import('../components/Content/WisdomSite'),
                            meta: {
                                title: '河南南秀数智科技有限公司'
                            }
                        },
                        /*智慧投影*/
                        {
                            path: '/home/content/contentWisdomProjection',
                            name: 'contentWisdomProjection',
                            component: () => import('../components/Content/WisdomProjection')
                        },
                        /*智慧滑轨屏*/
                        {
                            path: '/home/content/contentSlideScreen',
                            name: 'contentSlideScreen',
                            component: () => import('../components/Content/SlideScreen')
                        },
                        /*智能测量设备*/
                        {
                            path: '/home/content/contentResiliometer',
                            name: 'contentResiliometer',
                            component: () => import('../components/Content/Resiliometer')
                        },
                        /*互动点子沙盘*/
                        {
                            path: '/home/content/contentInteraction',
                            name: 'contentInteraction',
                            component: () => import('../components/Content/Interaction')
                        },
                        /*VR安全体验区*/
                        {
                            path: '/home/content/contentVR',
                            name: 'contentVR',
                            component: () => import('../components/Content/VR')
                        },
                        /*工法质量样板*/
                        {
                            path: '/home/content/contentQuality',
                            name: 'contentQuality',
                            component: () => import('../components/Content/Quality')
                        },
                        /*安全教育*/
                        {
                            path: '/home/content/contentSafetyEducation',
                            name: 'contentSafetyEducation',
                            component: () => import('../components/Content/SafetyEducation')
                        }
                    ]
                },
                /*企业资质*/
                {
                    path: '/home/enterPrise',
                    name: 'Enterprise',
                    component: Enterprise,
                    meta: {
                        title: '企业资质'
                    }
                },
                /*产品介绍*/
                {
                    path: '/home/Buy',
                    component: Buy,
                    redirect: '/home/Buy/VR',
                    meta: {
                        title: '企业产品'
                    },
                    children: [
                        /*智慧工地*/
                        {
                            path: "/home/Buy/WisdomSite",
                            name: 'BuyWisdomSite',
                            component: () => import('../components/Buy/WisdomSite')
                        },
                        /*安全教育*/
                        {
                            path: '/home/Buy/SafetyEducation',
                            name: 'SafetyEducation',
                            component: () => import('../components/Buy/SafetyEducation')
                        },
                        /*智能测量设备*/
                        {
                            path: '/home/Buy/Resiliometer',
                            name: 'Resiliometer',
                            component: Resiliometer,
                            meta: {
                                title: '智能回弹仪'
                            },
                        },
                        /*智慧党建滑轨屏*/
                        {
                            path: '/home/Buy/SlideScreen',
                            name: 'SlideScreen',
                            component: () => import('../components/Buy/SlideScreen'),
                            meta: {
                                title: '智慧党建滑轨屏'
                            }
                        },
                        /*智慧投影*/
                        {
                            path: '/home/Buy/Projection',
                            name: 'Projection',
                            component: () => import('../components/Buy/Projection'),
                            meta: {
                                title: '智慧投影'
                            }
                        },
                        /*VR服务*/
                        {
                            path: '/home/Buy/VR',
                            name: 'VR',
                            component: VR,
                            meta: {
                                title: 'VR服务'
                            }
                        },
                        /*AR服务*/
                        {
                            path: '/home/Buy/AR',
                            name: 'AR',
                            component: AR,
                            meta: {
                                title: 'AR服务'
                            }
                        },
                        /*安全体验馆*/
                        {
                            path: '/home/Buy/Experience',
                            name: 'Experience',
                            component: Experience,
                            meta: {
                                title: '安全体验馆'
                            }
                        },
                        /*质量样板展示区*/
                        {
                            path: '/home/Buy/Quality',
                            name: 'Quality',
                            component: Quality,
                            meta: {
                                title: '质量样板展示区'
                            }
                        },
                        /*互动台*/
                        {
                            path: '/home/Buy/Interaction',
                            name: 'Interaction',
                            component: Interaction,
                            meta: {
                                title: '物体识别互动台'
                            }
                        },
                        /*三维立体展示柜*/
                        {
                            path: '/home/Buy/ThreeDimensional',
                            name: 'ThreeDimensional',
                            component: ThreeDimensional,
                            meta: {
                                title: '三维立体展示柜'
                            }
                        },
                    ]
                },
                {
                    path: '/home/buyGo',
                    name: 'BuyGo',
                    component: BuyGo,
                    meta: {
                        title: '购买页面'
                    }
                },
                /*关于我们*/
                {
                    path: '/home/AboutUs',
                    component: AboutUs,
                    meta: {
                        title: '关于我们'
                    },
                    children: [
                        /*公司简介*/
                        {
                            path: '/',
                            name: 'CompanyProfile',
                            component: CompanyProfile,
                            meta: {
                                title: '公司简介'
                            },
                        },
                    ]
                },
                /*新闻资讯*/
                {
                    path: '/home/News',
                    component: News,
                    meta: {
                        title: '新闻资讯'
                    },
                    children: [
                        {
                            path: '/',
                            name: 'NewsProfile',
                            component: NewsProfile,
                            meta: {
                                title: '行业新闻'
                            },
                        },
                        {
                            path: '/home/News/NewsOne',
                            name: 'NewsOne',
                            component: NewsOne,
                            meta: {
                                title: '实测实量管理系统亮相中建系统第三届技术论坛'
                            },
                        },
                        {
                            path: '/home/News/NewsTwo',
                            name: 'NewsTwo',
                            component: NewsTwo,
                            meta: {
                                title: '2020年中建科技月中建五局第三届技术论坛-南秀科技虚拟质量样板荣获二等奖'
                            },
                        },
                        {
                            path: '/home/News/NewsThree',
                            name: 'NewsThree',
                            component: NewsThree,
                            meta: {
                                title: '南秀科技开启建筑施工数据采集数字化应用新赛道'
                            },
                        },
                        {
                            path: '/home/News/NewsFour',
                            name: 'NewsFour',
                            component: NewsFour,
                            meta: {
                                title: '建筑业协会各位领导参观指导南秀科技产品'
                            },
                        },
                        {
                            path: '/home/News/NewsFive',
                            name: 'NewsFive',
                            component: NewsFive,
                            meta: {
                                title: '南秀科技携众多科技产品助力国基建设观摩会成功举办'
                            },
                        },
                        {
                            path: '/home/News/NewsSix',
                            name: 'NewsSix',
                            component: NewsSix,
                            meta: {
                                title: '热烈欢迎河南省政协副主席高体建等一众领导莅临智慧岛及南秀科技参观指导！'
                            },
                        },
                        {
                            path: '/home/News/NewsSeven',
                            name: 'NewsSeven',
                            component: NewsSeven,
                            meta: {
                                title: '热烈欢迎陕西省宝鸡市港务区领导莅临南秀科技参观指导！'
                            },
                        },
                        {
                            path: '/home/News/NewsEight',
                            name: 'NewsEight',
                            component: NewsEight,
                            meta: {
                                title: '为贯彻落实智慧岛建设推进会会议精神，加快推动南阳市和驻马店市智慧岛建设工作，打造双创实际版，7月1日上午，南阳高新区党工委副书记、管委会主任党俊伟和驻马店市发展改革委副主任...'
                            },
                        },
                         {
                            path: '/home/News/NewsNine',
                            name: 'NewsNine',
                            component: NewsNine,
                            meta: {
                                title: '为贯彻落实智慧岛建设推进会会议精神，加快推动南阳市和驻马店市智慧岛建设工作，打造双创实际版，7月1日上午，南阳高新区党工委副书记、管委会主任党俊伟和驻马店市发展改革委副主任...'
                            },
                        }
                    ]
                },
                /*联系我们*/
                {
                    path: '/home/ContactUs',
                    name: 'ContactUs',
                    component: () => import('../components/ContactUs')
                },
                /*智慧工地*/
                {
                    path: '/home/WisdomSite',
                    name: 'WisdomSite',
                    component: () => import('../components/WisdomSite'),
                    meta: {
                        title: "智慧工地"
                    }
                }
            ]
        },
    ]
});

router.beforeEach((to, from, next) => {
    /* 路由发生变化修改页面title */
    if (to.meta.title) {
        document.title = to.meta.title
    }
    next()
});

// 跳转过后能够直接到顶点
// router.afterEach((to, from, next) => {
//     document.body.scrollTop = 0;
//     document.documentElement.scrollTop = 0;
// });

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js